export default __webpack_public_path__ + "static/media/move_jack.228007d3.mp3";